import { startLandingAnalytics } from "./lib/product-analytics.ts";
import { QueryClient } from "@tanstack/react-query";
import { bootstrapApplication } from "./lib/bootstrap.tsx";
import "./index.css";

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 30_000,
      retry: 1,
    },
  },
});

const API_URL = import.meta.env.VITE_API_URL || "";

const root = document.getElementById("root");
if (!root) throw new Error("Root element not found");

document.body.dataset.hcBoot = "1";
// Set only by the release command. It is intentionally non-secret and gives
// every production entry bundle an observable identity for cache-safe rollback
// and custom-domain verification.
const releaseId = import.meta.env.VITE_RELEASE_ID;
if (releaseId) document.body.dataset.hcRelease = releaseId;
bootstrapApplication({ root, apiUrl: API_URL, queryClient, releaseId });

startLandingAnalytics(import.meta.env.VITE_AGENTBEACON_WEBSITE_KEY);
